import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const REF_KEY = "rr_ref";
const visitorId = () => {
  let v = localStorage.getItem("rr_vid");
  if (!v) { v = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9_-]/g, ""); localStorage.setItem("rr_vid", v); }
  return v;
};
export const captureReferral = () => {
  const ref = new URLSearchParams(window.location.search).get("ref");
  if (ref && /^[A-Za-z0-9]{4,20}$/.test(ref)) {
    localStorage.setItem(REF_KEY, JSON.stringify({ code: ref.toUpperCase(), at: Date.now() }));
    api.post(`/referrals/${ref.toUpperCase()}/click`, { visitor_id: visitorId() }).catch(() => {});
    const url = new URL(window.location.href);
    url.searchParams.delete("ref");
    window.history.replaceState(null, "", url.pathname + url.search + url.hash);
  }
};
export const referralCode = () => {
  try {
    const r = JSON.parse(localStorage.getItem(REF_KEY) || "null");
    return r && Date.now() - r.at < 30 * 24 * 3600 * 1000 ? r.code : "";
  } catch { return ""; }
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cr_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config.method === "post" && config.url === "/enquiries" && config.data && !config.data.ref_code) {
    const code = referralCode();
    if (code) config.data = { ...config.data, ref_code: code };
  }
  return config;
});

export const WHATSAPP_NUMBER = "919040003444";
export const PHONE_DISPLAY = "+91 90400 03444";
export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const customerWaLink = (phone, text) => {
  let digits = String(phone).replace(/\D/g, "");
  if (digits.length === 10) digits = `91${digits}`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
};

export const thankYouMessage = (e) =>
  `Hi ${e.name}! Thank you for riding with Random Rider 🌊 We hope you loved ${e.vehicle_name ? `the ${e.vehicle_name}` : "your trip"}${e.travel_dates ? ` on ${e.travel_dates}` : ""}. Could you share a photo and a few words about your Puri moment? It takes a minute and helps other travellers: ${window.location.origin}/#reviews — Team Random Rider, +91 90400 03444`;

export default API;
